<div class="modal">
  <i class="fal fa-times modal__close"
     (click)="close()"></i>
    <h2 class="mb-0125">Update Languages</h2>
  <ng-container *ngIf="formControl">
    <app-language-form *ngIf="entityType.languageEnabled"
                       [formControl]="formControl">
    </app-language-form>

    <div class="col__ mt-0050">
      <button class="btn floatRight"
              type="button"
              data-test-id="saveBasicInfoButton"
              [appButtonSpinner]="isSaving"
              [disabled]="!formControl?.valid || isSaving"
              (click)="onSaveClicked()">Save</button>
    </div>
  </ng-container>

</div>
